'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  ALL: null,
  AVIATION: null,
  BUSINESS_SERVICE: null,
  CONSUMER_SERVICE: null,
  COMMUNICATIONS: null,
  CONSULTING: null,
  EVENT_SERVICES: null,
  FINANCIAL_SERVICES: null,
  HEALTHCARE: null,
  LEGAL_SERVICES: null,
  MARKETING_AGENCY: null,
  MEDIA: null,
  MANUFACTURING: null,
  RECRUITING: null,
  SOFTWARE: null,
  TECHNOLOGY: null,
  TRAVEL: null,
  EDUCATION: null,
  NONPROFIT: null,
  HARDWARE: null,
  COMMERCE: null,
  PROFESSIONAL_SERVICE: null,
  RESTAURANT: null,
  ENTERTAINMENT: null,
  REAL_ESTATE: null,
  OTHER_INDUSTRY: null
});